import { useTenant, useAnalytics } from '@parcel2go/npm-p2g-app';
import { fetchWithAnalytics } from '~/lib/fetch';
import { capturePromiseException } from '~/lib/metrics';
import useSWR from 'swr';
import { AddressLookupResponse } from '~/lib/types/edge-api-types';
import { EDGE_API } from '~/lib/constants';

/**
 * A hook used to try and parse an address string into a address model.
 */
export default function useParseAddress({ query }: { query: string | null | undefined }) {
  const { session } = useAnalytics();
  const { tenant } = useTenant();

  const response = useSWR<AddressLookupResponse>(
    query ? `${EDGE_API}/${tenant}/order-process/address/parse?query=${encodeURIComponent(query)}` : undefined,
    (url: string) =>
      fetchWithAnalytics(session, url)
        .then((res) => res.json())
        .catch(capturePromiseException),
    { revalidateOnFocus: true, revalidateOnReconnect: true }
  );

  return {
    parsing: query && response.isLoading,
    parsed: response.data?.result
  };
}
